import type { FaireProductEntity } from "../../entity_types/product";

export const p_mhd22qgw4f: FaireProductEntity = {
  token: "p_mhd22qgw4f",
  type: "product",
  name: "americana watercolor workbook",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/3b6cfe0d68150f641e9b5b759f1e230bab88a422f80eddebab88af2e6acc7bce.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/138d481bc83abd876597a33f69b958e45ec9fe9ce094cff50f91c16902f233e9.jpeg",
    "https://cdn.faire.com/fastly/cf53c37407699d3d01117a1528b12e943cb8932a2521ad1eb90d1eb117e247ff.jpeg",
    "https://cdn.faire.com/fastly/a51566df51345fd6ff0d0ff913a9e293b140f5abd35380fe7a6fbd74afbac04d.jpeg",
    "https://cdn.faire.com/fastly/b6a1c065813d0a65a5ee17cc307b25327fe076e495309028c72b7c17c62b1fc0.jpeg",
    "https://cdn.faire.com/fastly/d199b4fc224086f47230aa0238c2e1c35688cd30f933d97c6507fc5f711fc79c.jpeg",
    "https://cdn.faire.com/fastly/e3cc6aa6fd81a6ed39d2a721776cd7b665b811f4c3e8d451bdea031b0df03aed.jpeg",
    "https://cdn.faire.com/fastly/1fd851bfe6fdb50137537dd619c2369e6da306f0c385044f5f97fdee8ac4007e.jpeg",
    "https://cdn.faire.com/fastly/0433e7b674868fe844d0b20da1425d71e148f4dfe5b8bc5028f8f696c12a66e5.jpeg",
  ],
  priceDollars: 12,
  description:
    "Twelve illustrations of flags, stars, and classic summer scenes — each pre-outlined with step-by-step instructions. Paintings take about thirty minutes from start to finish, making it approachable for first-time painters and a favorite for gifting.\n\nA timely release for America's 250th anniversary in 2026. A strong May–July seller and a natural fit for home, gift, and patriotic-themed boutiques.\n",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:11:13.453Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
